import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const WorkspaceContext = createContext(null);

export const WorkspaceProvider = ({ children }) => {
  const { user } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("factlify_workspace") || null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setWorkspaces([]); return; }
    setLoading(true);
    try {
      const r = await api.get("/workspaces/mine");
      setWorkspaces(r.data.workspaces || []);
      const currentActive = localStorage.getItem("factlify_workspace") || r.data.active_workspace_id;
      if (currentActive) {
        const exists = r.data.workspaces.find((w) => w.id === currentActive);
        const effective = exists ? currentActive : r.data.active_workspace_id;
        setActiveId(effective);
        if (effective) localStorage.setItem("factlify_workspace", effective);
      }
    } catch (e) {
      // Not critical
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const switchWorkspace = useCallback((ws_id) => {
    localStorage.setItem("factlify_workspace", ws_id);
    setActiveId(ws_id);
    // Full reload to refetch everything with new workspace
    window.location.href = "/dashboard";
  }, []);

  const activeWorkspace = workspaces.find((w) => w.id === activeId) || null;
  const role = activeWorkspace?.role || "member";

  return (
    <WorkspaceContext.Provider value={{ workspaces, activeId, activeWorkspace, role, loading, refresh, switchWorkspace }}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export const useWorkspace = () => useContext(WorkspaceContext);
